exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/gbelizaire/Documents/ang2tut/resulatbac/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/gbelizaire/Documents/ang2tut/resulatbac/~/postcss-loader?{"ident":"postcss"}!C:/Users/gbelizaire/Documents/ang2tut/resulatbac/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 1